/**
 * The below file contains the constants used in the Earthquake Inmates Registration
 * @author: vishal.mishra@velsof.com
 * @date :06-02-2025
 */

export const GET_ALL_EARTHQUAKE_INMATES_REGISTRATION =
  "GET_ALL_EARTHQUAKE_INMATES_REGISTRATION";
export const SET_ALL_EARTHQUAKE_INMATES_REGISTRATION =
  "SET_ALL_EARTHQUAKE_INMATES_REGISTRATION";

export const REPORT_DATE_PARAM = "reportDate";
export const STATUS_PARAM = "status";
export const GET_ALL_CREATE_EARTHQUAKE_INMATES_REGISTRATION =
  "GET_ALL_CREATE_EARTHQUAKE_INMATES_REGISTRATION";
export const SET_ALL_CREATE_EARTHQUAKE_INMATES_REGISTRATION =
  "SET_ALL_CREATE_EARTHQUAKE_INMATES_REGISTRATION";

export const GET_ALL_UPDATE_EARTHQUAKE_INMATES_REGISTRATION =
  "GET_ALL_UPDATE_EARTHQUAKE_INMATES_REGISTRATION";
export const SET_ALL_UPDATE_EARTHQUAKE_INMATES_REGISTRATION =
  "SET_ALL_UPDATE_EARTHQUAKE_INMATES_REGISTRATION";

export const SET_EARTHQUAKE_INMATES_REGISTRATION = "SET_EARTHQUAKE_INMATES_REGISTRATION";

/**Constants for relief camp Import page */
export const CAMP_INMATES_REGISTRATION_IMPORT =
  "EARTHQUAKE_CAMP_INMATES_REGISTRATION_IMPORT";
export const CAMP_INMATES_REGISTRATION_IMPORT_EXCEL =
  "EARTHQUAKE_CAMP_INMATES_REGISTRATION_IMPORT_EXCEL";
/**Constants for relief camp Import page */

/**Constants for camp inmates registration export */
export const GET_EXPORT_CAMP_INMATES_DATA =
  "EARTHQUAKE_GET_EXPORT_CAMP_INMATES_DATA";
export const SET_EXPORT_CAMP_INMATES_DATA =
  "EARTHQUAKE_SET_EXPORT_CAMP_INMATES_DATA";
/**Constants for camp inmates registration import template */
export const GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA =
  "EARTHQUAKE_GET_IMPORT_TEMPLATE_CAMP_INMATES_DATA";
export const SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA =
  "EARTHQUAKE_SET_IMPORT_TEMPLATE_CAMP_INMATES_DATA";
